const RecordStatus = {
    NEW: "New",
    EDITABLE: "Editable",
    DELETED: "Deleted",
    READ_ONLY: "ReadOnly"
}

export default RecordStatus